import { MetaActions, MetaState, SET_META } from "./types";

export function setMeta(payload: MetaState): MetaActions {
  return {
    type: SET_META,
    payload,
  };
}
